import { helper } from "../../utils";

export default function DateContent({ timestamp }) {
    return (<div title="Created at" className="px-4 py-1 text-gray-400 text-right bg-gray-50 text-[11px] border-t font-medium">{helper.getCreatedTime(timestamp)}</div>);
}
